import React from 'react';

export default function Loading() {
    return (
        <div className="loading-wrapper fadein">
            <h4>Backend is spinning up, please wait...</h4>
            <div className="loading">
                <div className="background">
                    <i className="icon-heroku"></i>
                </div>
                <div className="spinner"></div>
            </div>
        </div>
    );
}
